import React, { Fragment } from 'react'
import girlavatar from "../../Assets/Images/girlavatar.png";
import { Link } from "react-router-dom";
import useAboutUs from '../../Hooks/WebPages/useAboutUs';

const AboutTRen = () => {


    const {
        isLoading,
        aboutUsData,
        handleAboutUs
    } = useAboutUs()

    return (
        <Fragment>
            <section className='py-100'>
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-5">
                            <img src={girlavatar} width={"100%"} alt="" />
                        </div>

                        <div className="col-lg-6">
                            <h2 className='heading'>
                                About Rennwrites. What we do?
                            </h2>

                            <p className='s-15'>
                                <div dangerouslySetInnerHTML={{ __html: aboutUsData?.section_one_content }} />

                                
                            </p>
                            <Link to={`/about-us`} className='btn btn-danger'>Read more</Link>

                        </div>
                    </div>
                </div>

            </section>
        </Fragment>
    )
}

export default AboutTRen